import { notificationsConstant } from '../../constants/notifications_constant'

const initialState = {
  loadingResults: false,
  results: [],
}

export function notificationsReducer(state = initialState, action) {
  switch (action.type) {
    case notificationsConstant.GET_ALL_REQUEST:
      return {
        ...state,
        loadingResults: true,
        showResults: false,
        results: [],
      }
    case notificationsConstant.GET_ALL_SUCCESS:
      return {
        ...state,
        loadingResults: false,
        showResults: true,
        results: action.results,
      }
    case notificationsConstant.GET_ALL_FAILURE:
      return {
        ...state,
        loadingResults: false,
        results: [],
        error: action.error,
      }
    default:
      return state
  }
}
